<template>
  <main class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner">
        <div class="l-error__message">
          <h1>
            404 Not Found<br />
            お探しのページが見つかりません。
          </h1>
          <p>
            お探しのページは一時的にアクセスができない状況にあるか、<br
              class="c-displayPc"
            />
            移動もしくは削除された可能性があります。
          </p>
        </div>

        <div class="l-error__btn">
          <div class="c-buttonWrap4">
            <ButtonLink
              tag="a"
              :href="/home/"
              style-type="primary"
              color="color2"
            >
              トップページへ
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import meta from "@/general/store/modules/meta";
import sitemap from "@/general/mixins/const/custom/sitemap";

@Options({
  props:{
    error: { type: Boolean, required: false, default: false }
  }
})
export default class Error404 extends Vue {
  error!: boolean;
  toppage = sitemap.TOP_PAGE;
  mounted() {
    meta.setDocumentTitle("お探しのページが見つかりません。");
    // this.$meta.setDocumentTitle("お探しのページが見つかりません。");
    // this.$page.isBreadcrumb = false;
    // this.$page.isPageHeader = false;
  }

  // watch: {
  //   $route() {
  //     this.$meta.setDocumentTitle("お探しのページが見つかりません。");
  //     this.$page.isBreadcrumb = false;
  //     this.$page.isPageHeader = false;
  //   }
  // }
}
</script>

<style lang="scss" scoped></style>
